import { render } from "./ChipsControl.vue?vue&type=template&id=63f09c5c&scoped=true&ts=true"
import script from "./ChipsControl.vue?vue&type=script&lang=ts"
export * from "./ChipsControl.vue?vue&type=script&lang=ts"

import "./ChipsControl.vue?vue&type=style&index=0&id=63f09c5c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\new2h5\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f09c5c"]])

export default __exports__